export * from './contactsPage';
export * from './paymentsInfoPage';
